<div *ngIf="localService.galleryViewUrl && localService.galleryViewUrl.length > 0">
    <div class="gallery-viewer-overlay">
        &nbsp;
    </div>
    <div class="gallery-viewer-container">
        <div class="row">
            <div class="col-12">
                <button class="button_icon button_icon_color icon_adjust"
                    style="font-size: 45px !important;margin-bottom: 10px !important;"
                    (click)="onAction(1)">assignment_return</button>
            </div>
        </div>
        <div class="row">
            <div class="col-12" [ngClass]="localService.galleryViewUrl.length > 1 ? 'multi-imgs' : 'single-img'">
                <ngb-carousel>
                    <ng-template ngbSlide *ngFor="let image of localService.galleryViewUrl">
                        <div class="picsum-img-wrapper">
                            <img [ngStyle]="{'max-width' : (localService.windowWidth - 100) + 'px','max-height' : (localService.windowHeight - 100) + 'px' }"
                                [src]="image" [alt]="image" />
                        </div>
                    </ng-template>
                </ngb-carousel>
            </div>
        </div>
    </div>
</div>